import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import html2pdf from "html2pdf.js";
import { getAggreementFormReview } from "../../../../auth/services/apiCalling";
import 'react-toastify/dist/ReactToastify.css';

const placeholderStyles = `
  .bold-text {
    font-weight: 600;
    color: #000000ff;
    display: inline;
  }
  
  .condition-number {
    font-weight: 700;
    color: #0066cc;
    margin-right: 8px;
  }
  
  .page-break-avoid {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  
  .condition-item {
    page-break-inside: avoid;
    break-inside: avoid;
    margin-bottom: 20px;
  }
  
  table {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  
  .signature-section {
    page-break-inside: avoid;
    break-inside: avoid;
  }
    p, span, div, td, th {
    color: #000000 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;

interface ReadOnlyAgreementProps {
  applicationId?: string;
}

const ReadOnlyAgreementForm = ({ applicationId }: ReadOnlyAgreementProps) => {
  const token = useSelector((state: any) => state.auth.token);
  const certificateRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [reviewedData, setReviewedData] = useState<any>(null);
  // const applicationId = "1001761919484329";

  const [formData, setFormData] = useState({
    at: "",
    on_the: "",
    day_of: "",
    two_Hundr: "",
    farmarName: "",
    companyName: "",
    aggrement_age: "",
    residing_at: "",
    Shri_M_s: "",
    registered_office_at: "",
    first_party: "",
    second_party: "",

    o_field1: '',
    o_field2: '',
    o_field3: '',
    o_field4: '',
    o_field5: '',
    o_field6: '',
    o_field7: '',
    o_field8: '',
    o_field9: '',
    return_for_period: '',
    provisions_of: '',
    sign_CF_sponsor: '',

    p_field1: '',
    p_field2: '',
    p_field3: '',
    p_field4: '',
    p_field5: '',
    p_field6: '',
    p_field7: '',
    p_field8: ''
  });

  const [rows, setRows] = useState([{
    Village_Name: "",
    Farmer_Name: "",
    Survey_No: "",
    Area_Hectar: "",
    Tehsil: "",
    District_Name: "",
    State: "",
  }]);

  const [conditionsData, setConditionsData] = useState<any[]>([]);
  const [role, setRole] = useState("self");

  // Fetch agreement data
  useEffect(() => {
    const fetchAgreementData = async () => {
      if (!applicationId) {
        toast.error("Application ID is required", { position: "top-right" });
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const response = await getAggreementFormReview(token, applicationId);

        if (response?.success) {
          setReviewedData(response.data);
          toast.success("Agreement data loaded successfully", { position: "top-right" });
        } else {
          toast.error(response?.message || "Failed to load agreement data", { position: "top-right" });
        }
      } catch (error) {
       
        toast.error("Error loading agreement data", { position: "top-right" });
      } finally {
        setIsLoading(false);
      }
    };

    fetchAgreementData();
  }, [applicationId, token]);


  // Populate form data when reviewedData is available
  useEffect(() => {
    if (reviewedData) {
      setFormData({
        at: reviewedData?.agreement_At || "",
        on_the: reviewedData?.agreement_on_the || "",
        day_of: reviewedData?.agreement_day_of || "",
        two_Hundr: reviewedData?.agreement_twozerozero || "",
        farmarName: reviewedData?.Farmer_Name || "",
        companyName: reviewedData?.Company_Name || "",
        aggrement_age: reviewedData?.agreement_age || "",
        residing_at: reviewedData?.agreement_residingAt || "",
        Shri_M_s: reviewedData?.AgreementFirstPartyName || "",
        registered_office_at: reviewedData?.AgreementFirstOfficeAt
          || reviewedData?.AgreementFirstOfficeAt
          || reviewedData?.registered_office_at
          || "",

        o_field1: reviewedData?.quarterForWhichReportPertains,
        o_field2: reviewedData?.totalQuantityPurchasedTonnes,
        o_field3: reviewedData?.totalValuePurchased,
        o_field4: reviewedData?.totalSupervisionChargesAssessed,
        o_field5: reviewedData?.totalSupervisionChargesPaid,
        o_field6: reviewedData?.totalQuantityForExportTonnes,
        o_field7: reviewedData?.quantityForProcessingExportTonnes,
        o_field8: reviewedData?.quantityOfAgrProExports,
        o_field9: reviewedData?.quantityProcessedExportedTonnes,
        return_for_period: reviewedData?.returnForPeriodOf,
        provisions_of: reviewedData?.provisionsOf,
        sign_CF_sponsor: reviewedData?.signOfContractFarmingSponsor,

        p_field1: reviewedData?.nameOfCommodity,
        p_field2: reviewedData?.nOoFfARMERContractSigned,
        p_field3: reviewedData?.areainHa,
        p_field4: reviewedData?.quantityInTonnes,
        p_field5: reviewedData?.totalQuantityOfProducePurchased,
        p_field6: reviewedData?.valPaidtoFarmers,
        p_field7: reviewedData?.paymentOutNoFarmers,
        p_field8: reviewedData?.paymentOutstandingAmount,

        first_party: reviewedData?.FirstPartyPresenceName || "",
        second_party: reviewedData?.SecondPartyPresenceName || "",
      });

      const villages = reviewedData?.textField?.villageData || reviewedData?.Village_details;
      if (villages?.length) {
        setRows(villages.map((village: any) => ({
          Village_Name: village.Village_Name || "",
          Farmer_Name: village.Farmer_Name || "",
          Survey_No: village.Survey_No || "",
          Area_Hectar: village.Area_Hectar || "",
          Tehsil: village.Tehsil || "",
          District_Name: village.District_Name || "",
          State: village.State || "",
        })));
      }

      if (reviewedData?.uploadedText?.Cultivation) {
        setConditionsData(reviewedData.uploadedText.Cultivation);
      }
    }
  }, [reviewedData]);

  const handleDownloadPDF = () => {
    setIsDownloading(true);

    const element = certificateRef.current;
    const opt = {
      margin: 0,
      filename: `Agreement_${applicationId || 'document'}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        letterRendering: true
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait'
      },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
        before: '.page-break-before',
        after: '.page-break-after',
        avoid: ['.page-break-avoid', '.condition-item', 'table', '.signature-section']
      }
    };

    html2pdf().set(opt).from(element).save().then(() => {
      setIsDownloading(false);
      toast.success('Agreement downloaded successfully!', { position: "top-right" });
    }).catch((error) => {
      setIsDownloading(false);
      toast.error('Failed to download agreement', { position: "top-right" });

    });
  };

  // Show loading state
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
            <span className="visually-hidden text-white">Loading...</span>
          </div>
          <h4>Loading Agreement Data...</h4>
        </div>
      </div>
    );
  }

  // Show error state if no data
  if (!reviewedData) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        <div className="text-center">
          <i className="feather feather-alert-circle text-danger mb-3" style={{ fontSize: "3rem" }}></i>
          <h4>No Agreement Data Found</h4>
          <p className="text-muted">Unable to load agreement for ID: {applicationId}</p>
        </div>
      </div>
    );
  }

  const renderConditionContent = (condition: any) => {
    let itemHtml = condition.item || "";

    // Replace input fields with bold values
    if (condition.isBlankExist && Array.isArray(condition.blank)) {
      condition.blank.forEach((blankItem: any) => {
        const { blankVal, blankName } = blankItem;
        const value = condition[blankVal] || `[${blankName || blankVal}]`;

        const inputRegex = new RegExp(
          `<input\\s+([^>]*?)name=[\"\']${blankVal}[\"\']([^>]*)>`,
          'gi'
        );

        itemHtml = itemHtml.replace(inputRegex, `<strong>${value}</strong>`);
      });
    }

    // Handle table items if present
    if (condition.isTableExist && Array.isArray(condition.tableItems) && condition.tableItems.length > 0) {
      let tableHtml = '<table class="table table-bordered mt-3 mb-3 page-break-avoid" style="font-size: 1.1rem;"><tbody>';

      condition.tableItems.forEach((tableItem: any) => {
        const value = condition[tableItem.tableVal] || `[${tableItem.tableHeading || tableItem.tableVal}]`;
        tableHtml += `
          <tr>
            <td style="font-weight: 600; width: 40%; background-color: #f8f9fa; padding: 8px;">${tableItem.tableHeading || tableItem.tableVal}</td>
            <td style="width: 60%; padding: 8px;"><strong>${value}</strong></td>
          </tr>
        `;
      });

      tableHtml += '</tbody></table>';
      itemHtml += tableHtml;
    }

    return itemHtml;
  };

  // Filter out deleted conditions for display
  const activeConditions = conditionsData.filter(c => c.status !== 'deleted');

  return (
    <div className="text-black">
      <style>{placeholderStyles}</style>



      {/* Agreement Content */}
      <div className='w-100 bg-white' >
        {/* Download Button */}
        <div className="d-flex justify-content-end p-3">
          <button
            className='btn btn-primary'
            onClick={handleDownloadPDF}
            disabled={isDownloading}
          >
            {isDownloading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Downloading...
              </>
            ) : (
              <>
                <i className="feather feather-download me-2"></i>
                Download Agreement
              </>
            )}
          </button>
        </div>
        <div className="d-flex bg-white p-5 pt-0 rounded flex-column text-nightblue justify-content-center" ref={certificateRef}>
          <div className="text-center mb-4 page-break-avoid">
            <h2>FORM - M</h2>
            <h2>[SEE RULE 119(3)]</h2>
            <h2>AGREEMENT OF CONTRACT FARMING</h2>
          </div>

          <div className="border mb-4 text-black p-3 rounded-3 page-break-avoid">
            <div>
              <div className="mb-3">
                <h3>Agreement Role</h3>
                <p style={{ fontSize: "1.1rem" }}>
                  Agreement made by: <span className="bold-text">{reviewedData?.agreement_behalf == null ? "Sponsor (Self)" : "Company/Representative on behalf of Sponsor"}</span>
                </p>
              </div>
            </div>
          </div>
          
          <div className="mb-4 text-black page-break-avoid" style={{ fontSize: "1.25rem" }}>
            <p style={{ fontSize: "1.25rem" }} className="text-black">
              This Agreement is made and entered into at{" "}
              <span className="bold-text">{formData.at || "[Location]"}</span>{" "}
              on the{" "}
              <span className="bold-text">{formData.on_the || "[Day]"}</span>{" "}
              day of{" "}
              <span className="bold-text">{formData.day_of || "[Date]"}</span>{" "}
              20<span className="bold-text">{formData.two_Hundr || "[YY]"}</span>{" "}
              between{" "}
              <span className="bold-text">{formData.farmarName || "[Parties]"}</span>{" "}
              and{" "}
              <span className="bold-text">{formData.companyName || "[Parties]"}</span>{" "}
              age{" "}
              <span className="bold-text">{formData.aggrement_age || "[Age]"}</span>{" "}
              residing at{" "}
              <span className="bold-text">{formData.residing_at || "[Address]"}</span>{" "}
              hereinafter called the Party of the first Part (which expression
              shall, unless excluded by or repugnant to the context, be deemed to
              include his heirs, executors, administrators and assigns,) and
              Shri/M/s.{" "}
              <span className="bold-text">{formData.Shri_M_s || "[Company Name]"}</span>{" "}
              a Pvt./Public Limited Company incorporated under the provisions of
              Companies Act, 1956 and having its registered office at{" "}
              <span className="bold-text">{formData.registered_office_at || "[Office Address]"}</span>{" "}
              hereinafter called the Party of second Part (which expression shall,
              unless excluded by or repugnant to the context be deemed to include
              its successors and assigns.)
            </p>
          </div>

          <div className="page-break-avoid">
            <p style={{ fontSize: "1.25rem" }}>
              Whereas the party of the first Part is the owner/cultivator of the
              agricultural land bearing, the following particulars, namely:-
            </p>

            {/* Farmers Table */}
            <div
              id="table"
              className="w-100 overflow-hidden border bg-white border-secondary rounded mb-4 page-break-avoid"
            >
              {/* Header */}
              <div
                id="head"
                className="d-flex w-100 rounded-top border-bottom border-secondary"
                style={{ backgroundColor: "#CCE3FF" }}
              >
                <div className="col-6 d-flex">
                  <h4 className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "1rem" }}>
                    Village of Farmers
                  </h4>
                  <h4 className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "1rem" }}>
                    Name of Farmers
                  </h4>
                  <h4 className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "1rem" }}>
                    Survey No.
                  </h4>
                </div>
                <div className="col-6 d-flex">
                  <h4 className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "1rem" }}>
                    Area in Hectare
                  </h4>
                  <h4 className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "1rem" }}>
                    Tehsil
                  </h4>
                  <h4 className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "1rem" }}>
                    District
                  </h4>
                  <h4 className="col-3 p-2 justify-content-center d-flex align-items-center" style={{ fontSize: "1rem" }}>
                    State
                  </h4>
                </div>
              </div>

              {/* Data Rows */}
              {rows.map((row, index) => (
                <div
                  key={index}
                  className="d-flex border-bottom border-secondary"
                >
                  <div className="col-6 d-flex">
                    <div className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                      <span className="bold-text">{row.Village_Name || "-"}</span>
                    </div>
                    <div className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                      <span className="bold-text">{row.Farmer_Name || "-"}</span>
                    </div>
                    <div className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                      <span className="bold-text">{row.Survey_No || "-"}</span>
                    </div>
                  </div>
                  <div className="col-6 d-flex">
                    <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                      <span className="bold-text">{row.Area_Hectar || "-"}</span>
                    </div>
                    <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                      <span className="bold-text">{row.Tehsil || "-"}</span>
                    </div>
                    <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                      <span className="bold-text">{row.District_Name || "-"}</span>
                    </div>
                    <div className="col-3 p-2 justify-content-center d-flex align-items-center">
                      <span className="bold-text">{row.State || "-"}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="page-break-avoid" style={{ fontSize: "1.25rem" }}>
            <p>
              And whereas the party of the second Part is trading in agricultural
              produce and also providing technical know-how in respect of land
              preparation, nursery, fertilization, pest management, irrigation,
              harvesting and other related aspects of Cultivation Production of
              crops;
            </p>
            <p>
              And whereas the party of the second Part is interested in the items
              of the agricultural produce more particularly mentioned in the
              Schedule annexed hereunder;
            </p>
            <p>
              And whereas at the request of the party of the second Part, the
              party of the first part has agreed to cultivate and produce the
              items of agricultural produce mentioned in the Schedule annexed
              hereunder;
            </p>
            <p>
              And whereas the parties hereto have agreed to reduce in writing the
              terms and conditions stipulated in the matter hereinafter appearing;
            </p>
            <p>
              Now, these presents witnessed and the parties hereby agree as
              follows:-
            </p>
          </div>

          {/* Conditions */}
          <div className="">

            <div

              className="border border-secondary flex rounded-top"
              style={{ fontSize: "1.25rem", backgroundColor: "#CCE3FF" }}
            // style={{ }}
            >
              <div className="border-end border-secondary col-1 d-flex align-items-center justify-content-center">{"Sr No."}.</div>
              {/* <div 
                  className="d-inline col-11 p-3"
                  // dangerouslySetInnerHTML={{ __html: renderConditionContent(condition) }}
                /> */}
              <div className="d-inline col-11 p-3 text-center">Conditions</div>

            </div>

          </div>
          <div className="">
            {activeConditions.map((condition, index) => (
              <div
                key={condition.itemNo || index}
                className="border border-secondary flex"
                style={{ fontSize: "1.25rem" }}
              >
                <div className="border-end border-secondary col-1 d-flex align-items-center justify-content-center">{condition.itemNo}.</div>
                <div
                  className="d-inline col-11 p-3"
                  dangerouslySetInnerHTML={{ __html: renderConditionContent(condition) }}
                />
              </div>
            ))}
          </div>

          {/* Form-o begin */}
          <div className='bg-white text-black my-5'>
            <div className="text-center  mb-4">
              <h2>FORM - O</h2>
              <h2>[SEE RULE 121(10)]</h2>
              <h2 className='mx-5 px-5'>FORM FOR INFORMING THE PRODUCE PURCHASED WITH AN INTENTION TO EXPORT OR PROCESSING BY THE CONTRACT FARMING SPONSOR</h2>
            </div>
            <div>
              <p style={{ fontSize: '1.25rem' }}>
                Return for the period of <span className="bold-text">{formData?.return_for_period}</span>
              </p>
            </div>

            <div id='table' className='w-100 overflow-hidden border bg-white border-secondary rounded'>

              <div id='head' className='d-flex w-100 text-center rounded-top border-bottom border-secondary' style={{ backgroundColor: "#CCE3FF" }}>
                <div className='col-6 d-flex'>
                  <h4 className='col-1 p-2 justify-content-center d-flex border-secondary border-end' style={{ fontSize: "12px" }}>Sr. No.</h4>
                  <h4 className={`col-2 p-2 justify-content-center d-flex border-secondary border-end `} style={{ fontSize: "12px" }}>Quarter for which report pertains</h4>
                  <h4 className={`col-2 p-2 justify-content-center d-flex border-secondary border-end `} style={{ fontSize: "10px" }}>Total quantity of agricultural produce purchased by contract farming sponsor in tonnes</h4>
                  <h4 className={`col-2 p-2 justify-content-center d-flex border-secondary border-end `} style={{ fontSize: "10px" }}>Total value of produce purchased</h4>
                  <div className='col-5 d-flex'>
                    <h4 className={`col-6 p-2 justify-content-center d-flex border-secondary border-end `} style={{ fontSize: "12px" }}>Total amount of supervision charges assessed</h4>
                    <h4 className={`col-6 p-2 justify-content-center d-flex border-secondary border-end `} style={{ fontSize: "12px" }}>Total amount of supervision charges paid in Rs. (Treasury Challan No. & Date)</h4>
                  </div>
                </div>
                <div className='col-6 d-flex'>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end `} style={{ fontSize: "12px" }}>Total quantity of agricultural produce purchased for export in tones</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end `} style={{ fontSize: "12px" }}>Quantity of agrucultural produce purchased for processing and exporting in tonnes</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end `} style={{ fontSize: "12px" }}>Quantity of agricultural produce exported</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end `} style={{ fontSize: "12px" }}>Quantity of agricultural produce processed and exported</h4>

                </div>
              </div>
              <div id='body' className='d-flex w-100 text-center rounded-top border-bottom border-secondary'>
                <div className='col-6 d-flex'>
                  <div className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>
                    <p>1</p>
                  </div>
                  <div className='col-2 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.o_field1}
                    </p>
                  </div>
                  <div className='col-2 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.o_field2}
                    </p>
                  </div>
                  <div className='col-2 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.o_field3}
                    </p>
                  </div>
                  <div className='col-5 d-flex'>
                    <div className='col-6 justify-content-center d-flex border-secondary border-end'>
                      <p className="bold-text">
                        {formData?.o_field4}
                      </p>
                    </div>
                    <div className='col-6 justify-content-center d-flex border-secondary border-end'>
                      <p className="bold-text">
                        {formData?.o_field5}
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-6 d-flex'>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.o_field6}
                    </p>
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.o_field7}
                    </p>
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.o_field8}
                    </p>
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.o_field9}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className=' mt-4'>
              <p style={{ fontSize: '1.25rem' }}>
                It is hereby certified that I/We undertake that the quantity of agricultural produce purchased for export/processing shall
                be exported or processed by me/us. Failure to do so shall result in action/penalty against me/us as per the provisions
                of
                <span className="bold-text mx-2">
                  {formData?.provisions_of}
                </span> 

                The Gujarat State Agricultural Produce Markets Act, 1963 (Guj. Act No. 20 of 1964) and rules
                made thereunder or conditions of registrations given to me/us which I am/we are ware of.
              </p>
              <div className='d-flex flex-column align-items-end'>
                <p className="bold-text">
                  {formData?.sign_CF_sponsor}
                </p>
                <p style={{ fontSize: '1.25rem' }}>

                  Signature of the Contract Farming Sponsor.
                </p>
              </div>
            </div>

          </div>
          {/* Form-o end */}

          {/* Form-p begin */}
          <div className='my-5 bg-white text-black'>
            <div className="text-center  mb-4">
              <h2>FORM - P</h2>
              <h2>[SEE RULE 121(9)]</h2>
              <h2 className='mx-5 px-5'>FORM OF ANNUAL ACCOUNTS OF CONTRACT FARMING SPONSOR</h2>
            </div>

            <div id='table' className='w-100 overflow-hidden border bg-white border-secondary rounded'>

              <div id='head' className='d-flex w-100 text-center rounded-top border-bottom border-secondary' style={{ backgroundColor: "#CCE3FF" }}>
                <div className='col-6 d-flex'>
                  <h4 className='col-1 p-2 justify-content-center d-flex border-secondary border-end' style={{ fontSize: "12px" }}>Sr. No.</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end`} style={{ fontSize: "12px" }}>Name of the commodity</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end`} style={{ fontSize: "12px" }}>No. of farmers with whom contracts signed</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end`} style={{ fontSize: "12px" }}>Area in ha. under contract Farming Agreement</h4>
                  <h4 className={`col-2 p-2 justify-content-center d-flex border-secondary border-end`} style={{ fontSize: "12px" }}>Quantity purchased in tones</h4>
                </div>
                <div className='col-6 d-flex'>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end`} style={{ fontSize: "12px" }}>Total value and quantity of produce purchased</h4>
                  <h4 className={`col-3 p-2 justify-content-center d-flex border-secondary border-end`} style={{ fontSize: "12px" }}>Values paid to the farmers</h4>
                  <div className='col-6'>
                    <div className='border-bottom border-secondary'>
                      <h4 className={`p-2 justify-content-center d-flex`} style={{ fontSize: "12px" }}>Payment outstanding for more than 15 days</h4>
                    </div>
                    <div className='d-flex h-100'>
                      <h4 className={`col-6 p-2 justify-content-center d-flex border-secondary border-end`} style={{ fontSize: "12px" }}>No. of farmers</h4>
                      <h4 className={`col-6 p-2 justify-content-center d-flex`} style={{ fontSize: "12px" }}>Amount in Rs.</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div id='body' className='d-flex w-100 text-center rounded-top border-bottom border-secondary' >
                <div className='col-6 d-flex'>
                  <div className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>
                    <p>1</p>
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.p_field1}
                    </p>
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.p_field2}
                    </p>
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.p_field3}
                    </p>
                  </div>
                  <div className='col-2 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.p_field4}
                    </p>
                  </div>
                </div>
                <div className='col-6 d-flex'>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.p_field5}
                    </p>
                  </div>
                  <div className='col-3 justify-content-center d-flex border-secondary border-end'>
                    <p className="bold-text">
                      {formData?.p_field6}
                    </p>
                  </div>
                  <div className='col-6'>
                    <div className='d-flex h-100'>
                      <div className='col-6 justify-content-center d-flex border-secondary border-end'>
                        <p className="bold-text">
                          {formData?.p_field7}
                        </p>
                      </div>
                      <div className='col-6 justify-content-center d-flex'>
                        <p className="bold-text">
                          {formData?.p_field8}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Form-p end */}

          {/* Signature section */}
          <div className="signature-section" style={{ fontSize: "1.25rem" }}>
            <p>
              In witness whereof the parties herein hereunto set and subscribed
              their respective hands and seals the day, month and year first
              above written.
            </p>
            <div className="d-flex justify-content-between mt-4">
              <div className="w-50">
                <p>
                  Signed, sealed and delivered by the within named 'Party of the
                  first Part' in the presence of
                </p>
                <p className="bold-text mt-3">
                  1. {formData.first_party || "[Witness Name]"}
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-5">
              <div className="w-50">
                <p>
                  Signed, sealed and delivered by the within named 'Party of the
                  second Part' in the presence of
                </p>
                <p className="bold-text mt-3">
                  1. {formData.second_party || "[Witness Name]"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyAgreementForm;